import React from "react";

import girlImg from "../assets/images/girlImage.webp";

import classes from "./RightSide.module.css";

const RightSide = () => {
  return (
    <div className={classes["wrapper"]} data-aos="fade-up">
      <img className={classes["img"]} src={girlImg} alt="" />
    </div>
  );
};

export default RightSide;
